import { Stack, Redirect } from "expo-router"
import { useAuth } from "hooks/use-auth"
import { ActivityIndicator, Platform } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"

export default function DashboardLayout() {
  const insets = useSafeAreaInsets()
  const auth = useAuth()

  if (auth.isLoading) {
    return <ActivityIndicator className="p-4" style={{ marginTop: insets.top }} />
  }

  if (!auth.data?.id) {
    return <Redirect href="/login" />
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        ...(Platform.OS === "android" ? { statusBarStyle: "dark" } : {}),
        sheetCornerRadius: 0,
        sheetGrabberVisible: false,
        fullScreenGestureEnabled: false,
        // sheetShouldOverflowTopInset: true,
      }}
    />
  )
}
